import React from 'react'
import { ChevronDown,  MapPin,  Navigation } from 'lucide-react'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import Text from './Text'
import breakpoints from 'theme/breakpoints'

export default function SelectLocation({ onClick, textButton = false }) {
  return (
    <ContainerSelect onClick={onClick}>
      <StyledSelectNavigation>
        <MapPin size={'18px'} color={colors.secondaryPurple} />
        <Text
          type='bold'
          color={colors.secondaryPurple}
          marginLeft='8px'
          marginRight='4px'
          paddingBottom={'0px'}
        >
          {textButton}
        </Text>
        <ChevronDown size={20} color={colors.secondaryPurple} />
      </StyledSelectNavigation>
    </ContainerSelect>
  )
}

const ContainerSelect = styled.div` 
  cursor: pointer;
`;

const StyledSelectNavigation = styled(Row)`
  width: auto;
  padding: 8px;
  top: 195px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.secondaryPurple};
  background: ${colors.neutral};
  border-radius: 30px;
  transition: all ease .25s;

  &:hover {
    transform: scale(1.03);
  }
`;